import {Injectable} from '@angular/core';
import {target} from './icons/target-icon';
import {realTimeUpdate} from './icons/real-time-icon';
import {visualAnalytics} from './icons/analytics-icon';
import {dataCollection} from './icons/data-collection-icon';
import {heavyPlus} from './icons/heavy-plus-icon';
import {heavyMinus} from './icons/heavy-minus-icon';
import {documentSvg} from './icons/documents-icon';
import {harmbuggerMenu} from './icons/harmbugger-menu';
import {heavyCross} from './icons/cross-icon';
import {accessibility} from './icons/aaccessibility-icon';
import {chatbotIcon} from './icons/chatbot-icon';
import {sendIcon} from './icons/send.icon';
import {separator} from './icons/separator';

export interface SvgIcon {
  name: string;
  tag: string; // raw SVG markup
}

@Injectable({
  providedIn: 'root',
})
export class SvgIconsService {
  // REGISTER CUSTOMER SVG ICONS HERE
  //Inspiration(uxwing, svgrepo)
  app_icons: SvgIcon[] = [
    { name: 'target', tag: target },
    { name: 'realtime', tag: realTimeUpdate },
    { name: 'visual-analytics', tag: visualAnalytics },
    { name: 'data-collection', tag: dataCollection },
    { name: 'heavy-plus', tag: heavyPlus },
    { name: 'heavy-minus', tag: heavyMinus },
    { name: 'document-icon', tag: documentSvg },
    { name: 'harmbuggerMenu', tag: harmbuggerMenu },
    { name: 'heavy-cross', tag: heavyCross },
    { name: 'accessibility', tag: accessibility },
    { name: 'chatbot', tag: chatbotIcon },
    {name: 'separator', tag: separator},
    { name: 'send-icon', tag: sendIcon },
  ];

  constructor() {}

  isSVG(name: string): boolean {
    return this.app_icons.some((icon) => icon.name === name);
  }

  getType(name: string): 'SVG' | 'MATERIAL' {
    return this.isSVG(name) ? 'SVG' : 'MATERIAL';
  }

  getSvg(name: string): string | undefined {
    const icon = this.app_icons.find((x) => x.name === name);
    return icon?.tag;
  }
}
